import { createOutlet } from './Outlet';
// Adds a fallback value when no value is present, so that it never suspends
export function fallback(outletDescriptor, fallbackValue) {
    return createOutlet({
        getCurrentValue: function () {
            try {
                return outletDescriptor.getCurrentValue();
            }
            catch (errorOrPromise) {
                if (typeof errorOrPromise.then === 'function') {
                    return fallbackValue;
                }
                throw errorOrPromise;
            }
        },
        hasCurrentValue: function () { return true; },
        subscribe: outletDescriptor.subscribe,
    });
}
//# sourceMappingURL=fallback.js.map